<template>
  <div>
    <v-container fluid grid-list-xs fill-height>
      <v-layout column warp>
        <template
          ><v-card-title>
            Prescription B2B Discount Management
            <v-spacer />
            <v-text-field
              :value="searchInput"
              label="Search"
              :persistent-hint="true"
              hint="Corporate name"
              prepend-icon="search"
              v-on:input="debounceInput"
            />
          </v-card-title>
          <v-data-table
            :options.sync="pagination"
            :headers="headers"
            :items="prescriptionDiscounts"
            :server-items-length="totalOrganization"
            :loading="loading"
            item-key="id"
            class="elevation-1 full-width full-height"
          >
            <v-progress-linear v-slot:progress color="blue" indeterminate />
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.organization_id">
                  <td class="text-center">{{ item.organization_id }}</td>
                  <td class="text-center">{{ item.name }}</td>
                  <td class="text-center">{{ item.discount_amount }}</td>
                  <td class="text-center">{{ item.discount_unit }}</td>
                  <td class="text-center">{{ item.total_usage_limit }}</td>
                  <td class="text-center">{{ item.total_usage }}</td>
                  <td class="text-center">{{ item.individual_usage_limit }}</td>
                  <td class="text-center">{{ item.usage_restriction_duration }}</td>
                  <td class="px-0 py-1 text-center">
                    <AddOrEditB2BDiscount
                      :isAdd="false"
                      @success="fetchData"
                      :corporateList="corporateList"
                      :prescriptionB2BDiscount="item"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </template>
      </v-layout>
      <AddOrEditB2BDiscount :isAdd="true" @success="fetchData" :corporateList="corporateList" />
    </v-container>
  </div>
</template>
<script>
import { debounce } from 'lodash';
import prescriptionDiscount from '../../../services/prescriptionDiscount';
import AddOrEditB2BDiscount from './components/AddOrEditB2BDiscount.vue';
import corporateService from '../../../services/corporate';
export default {
  name: 'B2BDiscount',
  components: {
    AddOrEditB2BDiscount,
  },
  data() {
    return {
      searchInput: '',
      loading: false,
      totalOrganization: null,
      pagination: {},
      headers: [
        {
          text: 'Organization ID',
          align: 'center',
          value: 'organization_id',
          sortable: true,
        },
        {
          text: 'Corporate Name',
          align: 'center',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Discount Amount',
          align: 'center',
          value: 'discount_amount',
          sortable: false,
        },
        {
          text: 'Discount Unit',
          align: 'center',
          value: 'discount_unit',
          sortable: false,
        },
        {
          text: 'Total Usage Limit',
          align: 'center',
          value: 'total_usage_limit',
          sortable: false,
        },
        {
          text: 'Total Usage',
          align: 'center',
          value: 'total_usage',
          sortable: false,
        },
        {
          text: 'Individual Usage Limit',
          align: 'center',
          value: 'individual_usage_limit',
          sortable: false,
        },
        {
          text: 'Usage Restriction Duration (days)',
          align: 'center',
          value: 'usage_restriction_duration',
          sortable: false,
        },
        {
          text: 'Action',
          align: 'center',
          value: 'organization_id',
          sortable: false,
        },
      ],
      prescriptionDiscounts: [],
      corporateList: [],
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;

      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
      let query = {};

      if (itemsPerPage !== -1) {
        query.per_page = itemsPerPage;
        query.page = page;
      }

      if (sortBy.length) {
        query.order = sortBy[0];
        query.sort = sortDesc[0] ? 'desc' : 'asc';
      }

      if (this.searchInput) query.q = this.searchInput;

      try {
        const data = await prescriptionDiscount.getPrescriptionDiscount(query);
        this.prescriptionDiscounts = data.data;
        this.totalOrganization = data.pagination.total;
      } finally {
        this.loading = false;
      }
    },
    debounceInput: debounce(function (e) {
      this.searchInput = e;
    }, 500),
    getCorporateList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        let query = {};
        query.per_page = 1000;
        query.order = 'id';
        query.sort = 'asc';

        corporateService
          .all(query)
          .then((data) => {
            this.loading = false;
            resolve(data);
          })
          .catch((err) => {
            this.loading = false;
            reject(err);
          });
      });
    },
  },
  watch: {
    searchInput() {
      this.fetchData();
    },
    pagination: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchData();
    this.getCorporateList().then((data) => {
      this.corporateList = data.data;
    });
  },
};
</script>
